import React, { useState, useEffect } from "react";

const initData = {
  heading: "Tech-Enabled Result-Driven Digital Marketing Agency",
  content:
    "We make sure your money is well spent and the campaigns elevate your brand to the next level.",
  btnText_1: "Start a Project",
  btnText_2: "Get Your Free Proposal",
};

const HeroOne = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    setData(initData);
  }, []);

  return (
    <section
      id="home"
      className="section welcome-area bg-overlay overflow-hidden d-flex align-items-center"
    >
      <div className="video-background">
        <video autoPlay loop muted className="video-bg">
          <source src="/img/backVideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="container">
        <div
          className="row align-items-center"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div
            className="col-12 col-md-7"
            style={{
              display: "flex",
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <div className="welcome-intro">
              {/* Heading without animation */}
              <h2 className="text-white">Tech-Enabled</h2>
              <h2 className="text-white">Result-Driven</h2>
              <h2 className="text-white">Digital Marketing Agency</h2>
              <p className="text-white my-4">{data.content}</p>
              <div className="button-group">
                <a
                  href="/free-consultation"
                  className="btn btn-bordered-white mb-2"
                >
                  {data.btnText_1}
                </a>
                {/* <a
                  href="/contact"
                  className="btn btn-bordered-white d-sm-inline-block"
                >
                  {data.btnText_2}
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroOne;